<template lang="pug">
  .row
    .col-md-6
      b-card
        p Profile
        content-loader(:height="7", v-if="alert.loading")
        form.mt-3(v-else-if="inputForm", @submit.prevent='onSubmit')
          .row
            .col-md-6
              b-form-group
                label Firstname
                b-form-input(name='firstname', type='text', v-model='inputForm.firstname', required='', placeholder='firstname', autocomplete="fname")
            .col-md-6
              b-form-group
                label Lastname
                b-form-input(name='lastname', type='text', v-model='inputForm.lastname', required='', placeholder='lastname', autocomplete="lname")
            .col-md-6
              b-form-group
                label Phone
                b-form-input(type='text', v-model='inputForm.phone', required='', placeholder='number', autocomplete="tel")
            .col-md-6
              b-form-group
                label Email
                b-form-input(type='email', v-model='inputForm.email', required='', placeholder='email', autocomplete="email")
            .col-6
              b-form-group(label="Password")
                b-form-input(type="password", name="passwordOld", v-model="inputForm.passwordOld", placeholder='Leave blank to keep unchanged')
            .col-6
              b-form-group(label="New Password")
                b-form-input(type="password", name="passwordNew", v-model="inputForm.passwordNew", placeholder='Leave blank to keep unchanged')
            .col-12(v-if="inputForm.passwordNew")
              p Password must be atleast 8 characters, with a number and a capital letter.
          .form-group
            button-load(type="submit", :flag="alert.busy", label="Save", classes="btn-outline")
            // b-button.btn-clear(@click="deleteAccount()") Delete Account
</template>

<script>
import { mapActions } from 'vuex';
import standardMix from '@/mixins/standardMix';
import { userService } from '@/services';

export default {
  components: {
  },
  mixins: [standardMix],
  data() {
    return {
      inputForm: null,
    };
  },
  computed: {
  },
  methods: {
    ...mapActions('account', ['updateAccount', 'logout']),
    onSubmit() {
      this.updateAccount({ form: this.inputForm, id: this.account.user.curator_id });
    },
  },
  async created() {
    try {
      this.busy();
      this.inputForm = await userService.getProfile(this.account.user.curator_id);
      this.clear();
    } catch (error) {
      this.error('Could not find user');
    }
  },
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/views/AccountProfile.vue